import { Box, Typography, Grid, MenuItem } from "@mui/material";
import { nanoid } from "@reduxjs/toolkit";
import { CalculatorOptionsGroup } from "../types/calculatorOptionsGroup";
import useChoiceCalculator from "../hooks/useChoiceCalculator";
import CalculatorSelectFieldItem from "../components/CalculatorSelectFieldItem";

const options: CalculatorOptionsGroup[] = [
  {
    title: "1. Confidence",
    subtitle:
      "How do you rate your confidence that you could get and keep an erection?",
    code: "confidence",
    required: true,
    options: [
      { display: "Very low", code: nanoid(), result: 1 },
      { display: "Low", code: nanoid(), result: 2 },
      { display: "Moderate", code: nanoid(), result: 3 },
      { display: "High", code: nanoid(), result: 4 },
      { display: "Very high", code: nanoid(), result: 5 },
    ],
  },
  {
    title: "2. Erection Firmness",
    subtitle:
      "When you had erections with sexual stimulation, how often were your erections hard enough for penetration?",
    code: "firmness",
    required: true,
    options: [
      { display: "No sexual activity", code: nanoid(), result: 0 },
      { display: "Almost never or never", code: nanoid(), result: 1 },
      {
        display: "A few times (much less than half the time)",
        code: nanoid(),
        result: 2,
      },
      { display: "Sometimes (about half the time)", code: nanoid(), result: 3 },
      {
        display: "Most times (much more than half the time)",
        code: nanoid(),
        result: 4,
      },
      { display: "Almost always or always", code: nanoid(), result: 5 },
    ],
  },
  {
    title: "3. Erection Maintenance (After penetration)",
    subtitle:
      "During sexual intercourse, how often were you able to maintain your erection after you had penetrated your partner?",
    code: "maintenance-after",
    required: true,
    options: [
      { display: "No sexual activity", code: nanoid(), result: 0 },
      { display: "Almost never or never", code: nanoid(), result: 1 },
      {
        display: "A few times (much less than half the time)",
        code: nanoid(),
        result: 2,
      },
      { display: "Sometimes (about half the time)", code: nanoid(), result: 3 },
      {
        display: "Most times (much more than half the time)",
        code: nanoid(),
        result: 4,
      },
      { display: "Almost always or always", code: nanoid(), result: 5 },
    ],
  },
  {
    title: "4. Erection Maintenance (To completion)",
    subtitle:
      "During sexual intercourse, how difficult was it to maintain your erection to completion of intercourse?",
    code: "maintenance-completion",
    required: true,
    options: [
      { display: "No sexual activity", code: nanoid(), result: 0 },
      { display: "Extremely difficult", code: nanoid(), result: 1 },
      { display: "Very difficult", code: nanoid(), result: 2 },
      { display: "Difficult", code: nanoid(), result: 3 },
      { display: "Slightly difficult", code: nanoid(), result: 4 },
      { display: "Not difficult", code: nanoid(), result: 5 },
    ],
  },
  {
    title: "5. Satisfaction",
    subtitle:
      "When you attempted sexual intercourse, how often was it satisfactory for you?",
    code: "satisfaction",
    required: true,
    options: [
      { display: "No sexual activity", code: nanoid(), result: 0 },
      { display: "Almost never or never", code: nanoid(), result: 1 },
      {
        display: "A few times (much less than half the time)",
        code: nanoid(),
        result: 2,
      },
      { display: "Sometimes (about half the time)", code: nanoid(), result: 3 },
      {
        display: "Most times (much more than half the time)",
        code: nanoid(),
        result: 4,
      },
      { display: "Almost always or always", code: nanoid(), result: 5 },
    ],
  },
];

export default function SHIMComponent() {
  const { selected, setSelected, result, resultText, incomplete } =
    useChoiceCalculator(options, (value) => {
      let interpretation = "";
      if (value >= 22) interpretation = "No erectile dysfunction";
      else if (value >= 17) interpretation = "Mild erectile dysfunction";
      else if (value >= 12)
        interpretation = "Mild to moderate erectile dysfunction";
      else if (value >= 8) interpretation = "Moderate erectile dysfunction";
      else interpretation = "Severe erectile dysfunction";

      return `Total Score: ${value}. ${interpretation}.`;
    });

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box flex={1} overflow="auto" p={2}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Sexual Health Inventory for Men (SHIM) is used to evaluate erectile
          dysfunction.
        </Typography>

        <Grid container spacing={2}>
          {options.map((group) => (
            <CalculatorSelectFieldItem
              key={group.code}
              text={group.title}
              value={selected[group.code]?.code || ""}
              onChange={(e) => {
                const option = group.options.find(
                  (o) => o.code === e.target.value,
                );
                setSelected((s) => ({ ...s, [group.code]: option }));
              }}
            >
              {group.options.map((option) => (
                <MenuItem key={option.code} value={option.code}>
                  {option.display}
                </MenuItem>
              ))}
            </CalculatorSelectFieldItem>
          ))}
        </Grid>
      </Box>

      <Box
        p={2}
        sx={{
          borderTop: 1,
          borderColor: "#D3D3D3",
        }}
      >
        <Typography variant="h5">Result</Typography>
        <Typography variant="body1">
          {incomplete ? (
            <i>Please fill out all required fields</i>
          ) : (
            <>
              <b>Score: {result}</b> - {resultText}
            </>
          )}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1, display: "block" }}
        >
          *Score Ranges: 1-7: Severe ED; 8-11: Moderate ED; 12-16: Mild-Moderate
          ED; 17-21: Mild ED; 22-25: No ED.
        </Typography>
      </Box>
    </Box>
  );
}
